import React, { useState, useEffect } from 'react';
import { Building2, LayoutDashboard, Calendar, Calculator, LogOut, User, FileText } from 'lucide-react';
import { supabase } from '../lib/supabase';

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export function Sidebar({ activeTab, setActiveTab }: SidebarProps) {
  const [userEmail, setUserEmail] = useState<string | null>(null);

  useEffect(() => {
    const getUserEmail = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        setUserEmail(user.email);
      }
    };
    getUserEmail();
  }, []);

  const menuItems = [
    { id: 'dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { id: 'calendar', icon: Calendar, label: 'Kalender' },
    { id: 'companies', icon: Building2, label: 'Kunder' },
    { id: 'calculator', icon: Calculator, label: 'Beregner' },
    { id: 'expedition', icon: FileText, label: 'Ekspeditionsoplysninger' },
  ];

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="w-64 bg-gray-800 h-screen p-4 flex flex-col">
      <div className="text-white text-2xl font-bold mb-8 pl-4">PipelinePro</div>
      <nav className="flex-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`w-full flex items-center gap-2 px-4 py-3 rounded-lg mb-2 ${
                activeTab === item.id
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
              }`}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
      
      {userEmail && (
        <div className="px-4 py-3 border-t border-gray-700">
          <div className="flex items-center gap-2 text-gray-300 mb-3">
            <User size={20} />
            <span className="truncate">{userEmail}</span>
          </div>
        </div>
      )}

      <button
        onClick={handleLogout}
        className="w-full flex items-center gap-2 px-4 py-3 rounded-lg text-red-400 hover:bg-gray-700"
      >
        <LogOut size={20} />
        <span>Log ud</span>
      </button>
    </div>
  );
}